// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"5e236300","29":"c0d0bb1f","340":"5a8e923f","363":"3840d7f4","449":"f77bb773","654":"ba7111e9","684":"12df713f","718":"50029cb9","723":"8870d5d2","725":"c0b07407","761":"7f17ddae","769":"763453e5","822":"d8240b7e","841":"55cff291","985":"8c39819a"}[chunkId] + ".chunk.js";
};